import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const mailApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
});

// Her istekte token ekle
mailApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Manuel set kalsın
export const setMailAuthToken = (token) => {
  if (token) mailApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  else delete mailApi.defaults.headers.common.Authorization;
};

export const mailService = {
  getFolders: async (sessionId) => {
    const res = await mailApi.get("/api/mail/folders", { params: { sessionId } });
    return res.data;
  },

  getMessages: async ({ sessionId, folder = "INBOX", take = 25, beforeUid }) => {
    const params = { sessionId, folder, take };
    if (beforeUid !== undefined && beforeUid !== null && String(beforeUid).trim() !== "") {
      params.beforeUid = beforeUid;
    }
    const res = await mailApi.get("/api/mail/messages", { params });
    return res.data;
  },

  getMessageDetail: async ({ sessionId, folder = "INBOX", uid }) => {
    const res = await mailApi.get(`/api/mail/messages/${uid}`, {
      params: { sessionId, folder },
    });
    return res.data;
  },

  setFlags: async ({ uid, sessionId, folder = "INBOX", isRead }) => {
    const res = await mailApi.patch(`/api/mail/messages/${uid}/flags`, {
      sessionId,
      folder,
      isRead,
    });
    return res.data;
  },

  moveMessage: async ({ uid, sessionId, fromFolder, toFolder }) => {
    const res = await mailApi.post(`/api/mail/messages/${uid}/move`, {
      sessionId,
      fromFolder,
      toFolder,
    });
    return res.data;
  },

  sendMail: async ({
    sessionId,
    fromEmail,
    to = [],
    cc = [],
    bcc = [],
    subject = "",
    bodyText = "",
    bodyHtml = "",
  }) => {
    const res = await mailApi.post("/api/mail/send", {
      sessionId,
      fromEmail,
      to,
      cc,
      bcc,
      subject,
      bodyText,
      bodyHtml,
    });
    return res.data;
  },

  // Ek indirme için relative url en sağlam yöntem
  downloadAttachmentUrl: ({ uid, attachmentId, sessionId, folder = "INBOX" }) => {
    const qs = new URLSearchParams({ sessionId, folder }).toString();
    return `/api/mail/messages/${uid}/attachments/${attachmentId}?${qs}`;
  },

  getContacts: async ({ sessionId, q, take = 10 }) => {
    const res = await mailApi.get("/api/mail/contacts", {
      params: { sessionId, q, take },
    });
    return res.data;
  },

};
